import React, {useState} from "react";
import {Tabs} from "antd";
import PrepData from "../PrepData/PrepData";
import CreateModel from "../CreateModel/CreateModel";

const ModelTraining = () => {
    const [activeKey, setActiveKey] = useState("prep");

    const items = [
        {label: "Prepare Data", key: "prep", children: <PrepData/>},
        {label: "Create Model", key: "create", children: <CreateModel/>},
    ];

    return (
        <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            items={items}
            type="card"
            style={{margin: "0 auto"}}
        />
    );
};

export default ModelTraining;
